'use client';

import Script from 'next/script';

export function BaiduAnalytics() {
  return (
    <Script id="_next-baidu" src="https://hm.baidu.com/hm.js?6aaa59948703c6b6994e81ce85bf7478" strategy="lazyOnload" />
  );
}
